export const loginMessage = 'Log in to CipherStreet API'
export const apiUrl = process.env.REACT_APP_BACKEND_API
export const loginType = 'email'
export const PROJECT_NAME = 'cipher-street-admin'

export const loginOperationId = (type) => {
  let operationId = 'createSessionByEmail'

  if (type === 'wallet') {
    operationId = 'createSessionByWallet'
  }

  if (type === '2fa') {
    operationId = 'createSessionByAttemptToken'
  }

  return operationId
}
